import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { ILeadFormModel } from '../../../typings'
import { ILocationType } from '@user/store/locationTypes/typings'

export function useHandlers({ name }) {
  const { setFieldValue } = useFormikContext<ILeadFormModel>()

  const handelChange = useCallback((value: ILocationType | null) => {
    setFieldValue(name, value?.id)
  }, [])

  const handelFocus = useCallback(() => {
    setFieldValue('assignmentRuleFieldFocused', true)
  }, [setFieldValue])

  const handelBlur = useCallback(() => {
    setFieldValue('assignmentRuleFieldFocused', false)
  }, [setFieldValue])

  return {
    handelChange,
    handelFocus,
    handelBlur,
  }
}
